import React from 'react';
import './List.scss';
import './List-media.scss';
import { Props } from './interfaces';

const List = ({ list, title, check = false, mt0 = false, tagTitle = 'h4', classP = 'body1' }: Props) => {
  return (
    <ul className={`list${check ? ' list_check' : ''}`}>
      {title ? (
        <div
          className={`list__title${mt0 ? ' list__title_mt0' : ''}`}
          dangerouslySetInnerHTML={{ __html: `<${tagTitle}>${title}</${tagTitle}>` }}
        ></div>
      ) : null}
      {list.map((item, i) => (
        <li className="list__li" key={i}>
          <p className={classP} dangerouslySetInnerHTML={{__html: item}}/>
        </li>
      ))}
    </ul>
  );
};

export default List;
